@if (uiController === UIControlTyp.MultiSelectList) {
  <kendo-multiselect
    textField="name"
    valueField="id"
    placeholder="Wählen Sie einen Wert aus"
    [data]="ProjectRiskRatingList"
    [(ngModel)]="ProjectRiskRatings"
    (valueChange)="valueChanged()"
    [filterable]="true"
    (filterChange)="filterProjectRisk($event)">
  </kendo-multiselect>
}
@if (uiController === UIControlTyp.DropDownList) {
  <kendo-dropdownlist
    class="fdb-kendo-dropdown"
    textField="name"
    valueField="id"
    [data]="ProjectRiskRatingList"
    [(ngModel)]="ProjectRiskRating"
    (valueChange)="valueChanged()">
  </kendo-dropdownlist>
}
@if (uiController === UIControlTyp.GridSingleValueField) {
  {{ getName() }}
}
